// extracted by mini-css-extract-plugin
module.exports = {"image":"mediaWithAuthHeader_image__xPbsT","video":"mediaWithAuthHeader_video__C75_E"};